<script setup lang="ts">
import { InputPrimary } from '@shared/ui/input'

import { useTutorApplicationStore } from '../../model/store'
import { useEmail } from '../../model/personal-information/email.hooks'

defineOptions({
  name: 'InputEmail',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  setEmail,
} = useEmail()

</script>

<template>
  <InputPrimary
    id="email"
    name="email"
    type="email"
    label="Email"
    placeholder="Email"
    :required="true"
    :value="tutorApplicationStore.form.email"
    :mode="mode"
    error-message="Please enter a valid email"
    @input="setEmail"
  />
</template>

